import { duration } from "@mui/material";

export const getSteps = (roomsData = []) => {
  const targetRoom = roomsData.find((r) => Number(r.is_reception) === 1) || null;
  
  console.log("roomsData reçu dans getSteps:", roomsData);
  console.log("targetRoom trouvé:", targetRoom);
  console.log("is_reception values:", roomsData.map(r => ({ label: r.label, is_reception: r.is_reception })));


  return [
    {
      id: "micro",
      target: "#tour-btn-Microphone",
      type: "tooltip",          // ← style normal avec boutons
      title: "Activer votre micro",
      content: "Cliquez sur l’icône micro pour activer ou couper votre son. Un indicateur visuel montre l’état en temps réel.",
      icon: "mic",
      placement: "top",
      firstStep: true,
    },

    {
      id: "camera",
      target: "#tour-btn-Camera",
      type: "tooltip",          // ← style normal avec boutons
      title: "Caméra activée / désactivée",
      content:
        "Activez ou désactivez votre caméra à tout moment. Les participants verront vos initiales si la caméra est désactivée.",
      icon: "videocam",
      placement: "top",
    },

    {
      id: "reactions",
      target: window.innerWidth < 480? "#tour-mobile" : "#tour-btn-reactions",
      type: "tooltip",          // ← style normal avec boutons
      title: "Réactions pendant le meeting",
      content:
        "Utilisez les réactions (👍👏❓😄🤝) pour interagir sans couper la parole. Une façon fluide de participer à la conversation sans déranger.",
      icon: "sentiment_satisfied",
      placement: "top",
      openMobileMore: window.innerWidth < 480? true : false,

    },
  
    {
      id: "screenShare",
      target:  window.innerWidth < 480? "#tour-mobile" : "#tour-btn-ScreenShare",
      type: "tooltip",          // ← style normal avec boutons
      title: "Partager votre écran",
      content:
        "Partagez votre écran, une fenêtre ou un onglet spécifique. Idéal pour présenter un document ou faire une démo en direct.",
      icon: "present_to_all",
      placement: "top",
      openMobileMore: window.innerWidth < 480? true : false,

    },

    {
      id: "room",
      target: targetRoom
      ? `[data-tour-room="${targetRoom.label.toLowerCase().replace(/\s+/g, '-')}"]`
      : null,
      title: "Cliquez sur l'étiquette",
      content: "En cliquant sur l'étiquette de la salle vous allez afficher ses paramètres.",
      icon: "calendar_month",
      placement: window.innerWidth < 480 ? "left" : "right",
      passive: true,
      excludeFromCount: true,
      action: "click-next",
      centerMapOnTarget: true,
      roomLabel: targetRoom?.label ?? null

    },


    {
      id: "room-click",
      target:"#tour-btn-room-create",
      title: "Organiser une réunion en salle",
      type: "tooltip",          // ← style normal avec boutons
      content:
        "Planifiez ou rejoignez une réunion dans une salle virtuelle dédiée.",
      icon: "calendar_month",
      placement:window.innerWidth < 480? "bottom" : "left",
      closeRoomMenuOnLeave:true,
      closeModalOnNext : true,

    },
  


    {
      id: "invite",
      target: '[data-tour="invite"]',
      type: "tooltip",          // ← style normal avec boutons
      title: "Inviter des personnes externes",
      content:
        "Invitez des personnes extérieures à votre organisation. Elles recevront un lien et arriveront directement dans l’espace d’accueil AIFEL.",
      icon: "person_add",
      placement: window.innerWidth < 480? "bottom" : "left",
      beforeOpenMenu: true,
      lockMenu: true,
      closeMenu : true
    },

    {
      id: "end",
      title: "Vous êtes prêt !",
      content:
        "Vous connaissez maintenant les fonctionnalités essenetielles d'AIFEL. Bonne réunion !"
        ,
      icon: "check",
      placement: "top",
      duration:"3000",
      passive: true, // pour un style particulier 
      action : "click-next", // pour cliquer sur le nom de la room  
      finalStep : true,
      excludeFromCount : true,

    },
  
  ];
}

